<template lang="pug">
div
  HeroSection
  SliderNoLimits
  SelectInst
  AprendizadoMao
  GoBeyond
  Security
  //- MultiplySale
  //- Partners
  WantToTry
</template>

<script>
import HeroSection from '../components/home/HeroSection'
import SliderNoLimits from '../components/home/SliderNoLimits'
import SelectInst from '../components/home/SelectInst'
import AprendizadoMao from '../components/home/AprendizadoMao'
import GoBeyond from '../components/home/GoBeyond'
import Security from '../components/home/Security'
import MultiplySale from '../components/home/MultiplySale'
import Partners from '../components/home/Partners'
import WantToTry from '../components/WantToTry'

export default {
  name: 'Home',
  components: {
    HeroSection,
    SliderNoLimits,
    SelectInst,
    AprendizadoMao,
    GoBeyond,
    Security,
    MultiplySale,
    Partners,
    WantToTry
  }
}
</script>

<style lang="sass"></style>
